export default "__VITE_ASSET__DWYE3595__"